import { View } from 'react-native';

import { neutralHex } from '@savvy/deprecated-shared/theme';

import { XSavvyLogo } from './x-savvy-logo';

export const LOGO_HEIGHT = 34;

export function XSavvyLogoHeader() {
  return (
    <View
      style={{
        height: LOGO_HEIGHT,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <View
        style={{
          width: LOGO_WIDTH,
        }}
      >
        <XSavvyLogo fill={neutralHex[300]} />
      </View>
    </View>
  );
}

const LOGO_WIDTH = 92;
